// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"621cde1b","279":"ae479120","454":"7ca5abfc","467":"ae479120","515":"ae479120","565":"ae479120","679":"fc8efc6f"}[chunkId] + ".chunk.css";
};